/**
 * Compare Section Jump
 * Adds a select dropdown to jump to corresponding sections in both
 * left (past) and right (current) columns simultaneously.
 */
var CompareSectionJump = (function() {
  'use strict';

  var initialized = false;
  var _onSelectChange = null;
  var _onNavigateChange = null;

  function getSelect() {
    return document.querySelector('[data-compare-section-jump]');
  }

  function getLeftColumn() {
    return document.querySelector('[data-compare-split-left]');
  }

  function getRightColumn() {
    return document.querySelector('[data-compare-split-right]');
  }

  function scrollColumn(column, sectionValue) {
    if (!column) return;

    var section = column.querySelector('[data-section="' + sectionValue + '"]');
    if (!section) return;

    var target = section.querySelector('[data-compare-scroll-target]') || section;

    var header = column.querySelector('.sticky');
    var headerHeight = header ? header.offsetHeight : 0;

    var targetRect = target.getBoundingClientRect();
    var columnRect = column.getBoundingClientRect();
    var offset = targetRect.top - columnRect.top + column.scrollTop - headerHeight - 8;

    column.scrollTo({ top: Math.max(0, offset), behavior: 'smooth' });
  }

  function onSelectChange(e) {
    var value = e.target.value;
    if (!value) return;

    var leftColumn = getLeftColumn();
    var rightColumn = getRightColumn();

    scrollColumn(leftColumn, value);
    scrollColumn(rightColumn, value);

    e.target.value = '';
  }

  function onNavigateChange(e) {
    var url = e.target.value;
    if (url) window.location.href = url;
  }

  function init() {
    if (initialized) return;
    initialized = true;

    var select = getSelect();
    if (select) {
      _onSelectChange = onSelectChange;
      select.addEventListener('change', _onSelectChange);
    }

    var navSelect = document.querySelector('[data-compare-navigate-select]');
    if (navSelect) {
      _onNavigateChange = onNavigateChange;
      navSelect.addEventListener('change', _onNavigateChange);
    }
  }

  function reset() {
    var select = getSelect();
    if (select && _onSelectChange) {
      select.removeEventListener('change', _onSelectChange);
      _onSelectChange = null;
    }

    var navSelect = document.querySelector('[data-compare-navigate-select]');
    if (navSelect && _onNavigateChange) {
      navSelect.removeEventListener('change', _onNavigateChange);
      _onNavigateChange = null;
    }

    initialized = false;
  }

  return { init: init, reset: reset };
})();

document.addEventListener('turbolinks:load', function() {
  CompareSectionJump.init();
});
document.addEventListener('turbo:load', function() {
  CompareSectionJump.init();
});
document.addEventListener('turbo:before-cache', function() {
  CompareSectionJump.reset();
});

if (document.readyState !== 'loading' && document.querySelector('[data-compare-section-jump]')) {
  CompareSectionJump.init();
}

window.CompareSectionJump = CompareSectionJump;
